import { Icon, IconsEnum, toIconsEnum } from 'components/Icons';

import { CardFavouriteBtn } from 'components/cards/components/cardFavouriteBtn';
import { ScommesseTableStatsFrame } from 'components/scommesseTable/scommesseTableStatsFrame';
import dynamic from 'next/dynamic';
import { retrieveFerri } from 'features/ippica/functions';
import styles from './IppicaScommesseTableSecondaryInfo.module.scss';
import { typeRapportoScuderiaDictionary } from 'features/ippica/types';
import { useCreateStatsPathByNumCavallo } from '../../hook';
import { useGetCavallo } from 'features/ippica/hooks';
import { useIsAuthenticated } from 'hooks/useIsAuthenticated';
import { useLazyGetDetailIppicaRaceQuery } from 'features/api/ippicaApiSlice';
import { useState } from 'react';

export const DynamicIppicaScommesseTableSecondaryInfo = dynamic(() =>
  import('features/ippica/components/ippicaScommesseTableRow/ippicaScommesseTableSecondaryInfo').then(
    (mod) => mod.IppicaScommesseTableSecondaryInfo
  )
);

export type IppicaScommesseTableSecondaryInfoProps = {
  providerID?: number;
  containerClassName?: string;
  keyCavallo: string;
  isOpen: boolean;
};

export const IppicaScommesseTableSecondaryInfo = ({
  keyCavallo,
  containerClassName,
  isOpen,
}: IppicaScommesseTableSecondaryInfoProps) => {
  const { id, isFavorite, ferri, hasParaocchi, numeroCavallo, rapportoScuderia, nomeCavalloPadre, nomeCavalloMadre } =
    useGetCavallo(keyCavallo);
  const isAuthenticated = useIsAuthenticated();
  let [isFavourite, setFavourite] = useState(isFavorite);

  let stats = useCreateStatsPathByNumCavallo(numeroCavallo);

  // const [trigger] = apiSlice.endpoints.getFavourites.useLazyQuery();
  const [trigger] = useLazyGetDetailIppicaRaceQuery();

  return (
    <div
      className={`${styles.container} ${containerClassName ? containerClassName : ''} ${
        isOpen ? styles.backgroundSelected : ''
      }`}
    >
      <div className={styles.firstCol}>
        {/* TODO CAPIRE FULL */}
        {ferri && ferri !== 'full' && (
          <Icon iconId={toIconsEnum(retrieveFerri(ferri))} className={styles.icon} color="var(--color-on-bg-primary)" />
        )}
        {hasParaocchi && (
          <Icon iconId={IconsEnum.CAVALLO_PARAOCCHI} className={styles.icon} color="var(--color-on-bg-primary)" />
        )}
        {rapportoScuderia && (
          <Icon
            iconId={toIconsEnum(typeRapportoScuderiaDictionary[`${rapportoScuderia}`])}
            className={styles.icon}
            color="var(--color-on-bg-primary)"
          />
        )}
      </div>
      <div className={styles.secCol}>
        {id && isAuthenticated && nomeCavalloPadre && nomeCavalloMadre && (
          <CardFavouriteBtn
            idGame={id}
            favourite={isFavourite}
            verticale={'Ippica'}
            className={styles.favBtn}
            colorIcon="var(--color-surface-01)"
            classIcon={styles.iconFav}
            classNameIconContainer={styles.iconContainerFav}
            triggerRefetch={() => {
              setFavourite((st) => {
                return st ? false : true;
              });
              // trigger({ idProgramma: codiceProgramma, idAvvenimento: numeroAvvenimento });
            }}
          />

          // <button type="button" className={styles.favBtn} onClick={() => setIsFav(!isFav)}>
          //   <Icon
          //     iconId={isFav ? IconsEnum.PREFERRED_ON : IconsEnum.PREFERRED_OFF}
          //     className={styles.iconFav}
          //     color={isFav ? 'var(--color-primary)' : 'var(--color-on-bg-secondary)'}
          //   />
          // </button>
        )}
        {stats && <ScommesseTableStatsFrame statsUrl={stats} className={styles.statsWrapper} title={'Statistiche'} />}
      </div>
    </div>
  );
};
